<!--
 * @Author: 朱占伟
 * @LastEditors: liyuntao
 * @description: 选择门店组件
 * @Date: 2021-07-27 20:23:29
 * @LastEditTime: 2022-06-30 18:42:17
-->

<template>

  <!-- store 选项按钮 -->
  <div class="flex justify-between align-center selectStore">
    <div class="title">Store</div>
    <div>
      <van-button
        class="obn-app mr-10"
        :class="{ 'obn-active': state.active === 1 }"
        plain
        :disabled="disabled"
        @click="selectApp(1)"
      >
        <template #icon>
          <img :src="google" alt="Google Play">
        </template>

        Google Play</van-button>
      <van-button
        class="obn-app"
        plain
        :class="{ 'obn-active': state.active === 2 || state.active === 3 }"
        :disabled="disabled"
        @click="selectApp(2)"
      >
        <template #icon>
          <img :src="ios">
        </template>
        App Store</van-button>
    </div>
  </div>
  <!-- 如果选择app store 选项按钮 -->
  <div v-show="isIpad && state.active >1" class="selectStore clearfix">
    <div class="float-right">
      <van-button
        class="obn-app"
        :class="{ 'obn-active': state.active === 3 }"
        plain
        :disabled="disabled"
        @click="selectApp(3)"
      >
        <template #icon>
          <img :src="ipad" alt="iPad">
        </template>
        iPad
      </van-button>
    </div>
    <div class="float-right">
      <van-button
        class="obn-app mr-10"
        :class="{ 'obn-active': state.active === 2 }"
        plain
        :disabled="disabled"
        @click="selectApp(2)"
      >
        <template #icon>
          <img :src="iphone" alt="iPhone">
        </template>
        iPhone
      </van-button>
    </div>
  </div>



</template>

<script>
import { reactive, watch, toRefs } from "vue";
import ios from "assets/images/icon/icon-apple.svg";
import google from "assets/images/icon/icon-google.svg";
import iphone from "assets/images/icon/icon-iphone.svg";
import ipad from "assets/images/icon/icon-ipad.svg";
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          eventName: "selectApp",
          active: 1,
          appInfo: {}
        };
      },
    },
    isIpad: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      active: props.config.appInfo ? props.config.appInfo.platform === 1 ? 1 : props.config.appInfo.deviceFamilies[0] : props.config.active || 1,
    });
    const { disabled } = toRefs(props);
    const selectApp = (val) => {
      // 触发事件
      emit(props.config.eventName, val);
      state.active = val; 
    };
    watch(
      () => props.config.active,
      (newVal) => {
        state.active = newVal ? newVal : 1;
      },
      { immediate: true }
    );
    watch(
      () => props.config.appInfo,
      (newVal, ol) => {
        state.active = newVal ? newVal.platform === 1 ? 1 : newVal?.deviceFamilies[0] : props.config.active || 1;
      },
      { immediate: true }
    );
    return {
      state,
      selectApp,
      ios,google,ipad,iphone
    };
  },
};
</script>
<style lang="scss" scoped>
.selectStore {
  margin: 0 auto;
  padding: 14px 10px;
  box-sizing: content-box;
  border-bottom: 1px solid #ebeef5;
  background-color: #fff;

  .obn-app {
    background: #fff;
    height: 32px;
    border-radius: $radius;
    padding: 0 10px;
    font-size: $fontText;
    color: $sign;

    :deep(.van-button__icon) {
      display: flex;
    }
  }

  .obn-active {
    background: #f8f7ff;
    border: 1px solid $main;
    color: $main;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    color: #1e183f;
  }

  .app-store-icon {
    width: 16px;
    height: 16px;
  }
}
</style>
